<div class="container-fluid background-blue container-head relative">
  <div class="row " *ngIf="isLogin">
    <div class="col-6">
      <button (click)="openmenu()" mat-icon-button *ngIf="isLogin" class="color-white">
        <mat-icon class="color-white">menu</mat-icon>
      </button>
    </div>
    <div class="col-6">
      <div class="row justify-content-end align-items-center">
        <div class="col-4">
          <button (click)="setShowToolbar()" mat-button class="color-white perfil">
            <mat-icon class="color-white">person</mat-icon>
            <span class="color-white">Mi perfil</span>
          </button>
        </div>
        <!-- <div class="col-4">
          <button (click)="showChangePasswordDialog()" mat-button class="color-white"><mat-icon
              class="color-white">lock</mat-icon> <span class="color-white">Cambiar contraseña</span></button>
        </div>
        <div class="col-4">
          <button (click)="exit()" mat-button class="color-white"><mat-icon class="color-white">logout</mat-icon> <span
              class="color-white">Cerrar sesión</span></button>
        </div> -->
      </div>
    </div>
  </div>
</div>
<mat-toolbar class="toolbar background-blue" [class]="{visible: showToolbar()}">
  <div class="option" (click)="openChangePassword()">
    <mat-icon class="option__icon">lock</mat-icon>
    <span class="option__description">Cambiar la contraseña</span>
  </div>
  <div class="option" (click)="exit()">
    <mat-icon class="option__icon">logout</mat-icon>
    <span class="option__description">Cerrar sesión</span>
  </div>
  <footer class="toolbar__footer">
    <p *ngIf="perfil().length > 0">
      <span>Perfil: </span> <strong>{{perfil()}}</strong>
    </p>
    <p *ngIf="agenteID().length > 0">
      <span>Agente: </span> <strong>{{agenteID()}}</strong>
    </p>
  </footer>
  <!-- <button class="block w-full" mat-button (click)="openChangePassword()">
    <mat-icon>lock</mat-icon>
    Cambiar contraseña
  </button>
  <button class="block w-full" mat-button (click)="exit()">
    <mat-icon>logout</mat-icon>
    Cerrar sesión
  </button> -->
</mat-toolbar>
